module.exports = __webpack_public_path__ + "static/img/gxfczb.2c6e17f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gxfczb.png
// module id = yVYf
// module chunks = 0